"use client";
import { useState } from 'react';
import { Button } from "react-bootstrap";
import { baseUrl } from "utils/constants";
import Modal from 'react-bootstrap/Modal';

export default function Elements() {
	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	return (
		<div className="cpr_container">

			<br /><br /><br /><br /><br /><br /><br />
			<div style={{ maxWidth: '904px' }} className='m-auto w-100'>
				<div className='row'>
					<div className='col-auto'>
						<div className=' border_radius--round24 bg_color_cement_light border d-flex align-items-center p-2'>
							<div className="spinner-border text-secondary w-16px h-16px" role="status">
								<span className="sr-only">Loading...</span>
							</div>
							<div className='ml-2 font_size--small_extra'>Initializing...</div>
						</div>
					</div>
					<div className='col-auto'>
						<div className='font_size--small_extra'>Voice Recording enabled:</div>
						<a className="mice_enabled"><img src="https://content.harstatic.com/media/icons/a_all/mic_icon_red.svg" /></a>
					</div>
				</div>


				<div className="user_bubble__wraper">
					<div className="user_bubble">
						<div className="user_bubble__text">
							Filter Property By: Status: OP, Property Type: ,Single Family, Category: ,new_entry, amenities: loft, Minimum Price: 15000, Maximum Price: 70000 I searched for properties with the following filters
						</div>
					</div>
				</div>

				<br /><br /><br />

				<div className="user_bubble__wraper">
					<div className='position-relative border border-color--cloudy-sky-light py-3 px-3 align-items-center' style={{ borderRadius: '25px', display: 'inline-flex', maxWidth: '920px', minWidth: '300px' }}>
						<div className='font_weight--semi_bold font_size--medium pr-2 align-self-start'>
							Filters applied:
						</div>
						<div className='d-flex flex-wrap'>
							<div className="btn btn--ordinary btn--small btn--filters_pills mr-2 mb-md-0 mb-2">City: Sugar Land</div>
							<div className="btn btn--ordinary btn--small btn--filters_pills mr-2 mb-md-0 mb-2">Acreage</div>
							<div className="btn btn--ordinary btn--small btn--filters_pills mr-2 mb-md-0 mb-2">With Half Bath</div>
							<div className="btn btn--ordinary btn--small btn--filters_pills mr-2 mb-md-0 mb-2">Min 3/4 Acre Lot (Acres)</div>
							<div className="btn btn--ordinary btn--small btn--filters_pills mr-2 mb-md-0 mb-2">Min 2+ Garage</div>
						</div>
					</div>
				</div>

				<br /><br /><br /><br /><br /><br />

				<div className="user_bubble__wraper">
					<div className='position-relative py-3 px-3 align-items-center bg_color_cement_light' style={{ borderRadius: '25px', display: 'inline-flex', maxWidth: '920px', minWidth: '300px' }}>
						<div className='font_weight--semi_bold font_size--medium pr-2'>
							Filters applied:
						</div>
						<div className='d-flex flex-wrap'>
							<div className="btn btn--ordinary btn--small btn--filters_pills mr-2 mb-md-0 mb-2">City: Sugar Land</div>
							<div className="btn btn--ordinary btn--small btn--filters_pills mr-2 mb-md-0 mb-2">Acreage</div>
							<div className="btn btn--ordinary btn--small btn--filters_pills mr-2 mb-md-0 mb-2">With Half Bath</div>
							<div className="btn btn--ordinary btn--small btn--filters_pills mr-2 mb-md-0 mb-2">Min 3/4 Acre Lot (Acres)</div>
							<div className="btn btn--ordinary btn--small btn--filters_pills mr-2 mb-md-0 mb-2">Min 2+ Garage</div>
						</div>
					</div>
				</div>

				<br /><br /><br />


			</div>

			<br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

			<br /><br /><br /><br /><br /><br /><br />

			<div className="input_bar">
				<div className="input_main_container">
					<div className="flex items-center p-8 rounded grow max-h-full">
						<div className="input_text_bar d-block chat-input align-items-baseline">
							<textarea
								placeholder="Enter a message..."
								className="form-control"
								spellCheck="false"
								defaultValue={""}
							/>
							<div className='voice_enabled'>
								<div className='pt-3 mt-2 ml-3 ml-1 cursor--pointer'><img src="https://content.harstatic.com/media/icons/close_black.svg"></img></div>
								<div className="voice_animation">
									<div className="voice_animation-inner">
										<div className="box a"></div>
										<div className="box b"></div>
										<div className="box c"></div>
										<div className="box d"></div>
										<div className="box a"></div>
										<div className="box b"></div>
										<div className="box c"></div>
										<div className="box d"></div>
										<div className="box a"></div>
										<div className="box b"></div>
										<div className="box c"></div>
										<div className="box d"></div>
										<div className="box a"></div>
										<div className="box b"></div>
										<div className="box c"></div>
										<div className="box d"></div>
									</div>
								</div>
								<div className='voice_send cursor--pointer'><img src='https://content.harstatic.com/media/icons/checkmark_auxialary.svg'></img></div>
							</div>
							<a className="p-2 mic_icon" href="#">
								<img
									style={{ width: 15, opacity: "0.6" }}
									src="https://content.harstatic.com/media/icons/a_all/mic_icon.svg"
								/>
							</a>
							<button
								type="button"
								className="btn btn--primary input_text_bar_btn d-flex align-items-center"
							>
								<img
									src="https://content.harstatic.com/media/icons/copilot/ai_node_arrow_white.svg"
									alt="Main content"
									style={{ display: "block" }}
								/>
							</button>
						</div>
					</div>
					<div className="footer_disclaimer font_size--small_extra color_auxiliary text-center pt-2 d-md-block d-none">
						HAR.AI may produce inaccurate information about listings,
						market, or facts.
						<a className="color_auxiliary" href="#">
							HAR.AI Privacy Notice
						</a>
					</div>
					<div className="footer_disclaimer font_size--small_extra_extra color_auxiliary text-center pt-2 d-md-none d-block">
						HAR.AI may provide inaccurate details. Check{" "}
						<a className="color_auxiliary" href="#">
							HAR.AI Privacy Notice
						</a>
					</div>
				</div>
			</div>

			<br /><br /><br /><br /><br /><br /><br />

			<div className="cpr_content">
				<div className="cpr_content_inner">

					<div>
						<Button variant="" className='btn btn--primary mb-5' onClick={handleShow}>Launch static backdrop modal</Button>

						<Modal
							show={show}
							onHide={handleClose}
							backdrop="static"
							keyboard={false}
							className='modal fade modal--medium'
						>
							<Modal.Header>
								<Modal.Title>Modal title</Modal.Title>
								<Button variant="" className='' onClick={handleClose}><img src="https://content.harstatic.com/media/icons/close_black.svg" /></Button>
							</Modal.Header>
							<Modal.Body>
								I will not close if you click outside me. Do not even try to press
								escape key.
							</Modal.Body>
							<Modal.Footer>
								<Button variant="primary">Submit</Button>
								<Button variant="" className='btn btn--shapeless' onClick={handleClose}>Close</Button>
							</Modal.Footer>
						</Modal>
					</div>


					<div className="ai_left_pane">
						<div className="d-flex flex-column h-100">
							<div className="py-4 px-3">
								<div className="row no-gutters">
									<div className="col">
										<div className="left_col_title">Search</div>
									</div>
									<div className="col-auto text-right">
										<a
											style={{ opacity: "0.6" }}
											className="d-inline-flex text-decoration-none font_size--small color_black font_weight--semi_bold align-items-center btn__bordered"
											href="#"
										>
											<img
												className="mr-2"
												style={{ width: 18 }}
												src="https://content.harstatic.com/media/icons/a_all/add_block_3.svg"
											/>{" "}
											<span className="pt-1">New</span>
										</a>
									</div>
								</div>
							</div>
							<div className="d-flex flex-column flex-grow-1 overflow-auto">
								<div className="cphl_container px-3">
									<div className="font_size--medium font_weight--semi_bold color_lighter">
										Today
									</div>
									<div className="cphl_item">
										<a
											href="https://har.com"
											className="cphl_item_text overflow-ellipsis"
										>
											Alling script for the first contact script for the first contact
										</a>
										<div className="cphl_item_dropdown dropdown dropdown dropdown--custom dropdown--custom_medium">
											<a
												className="pr-3"
												href="#"
												id="dropdownMenuButton"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<img
													style={{ width: 14 }}
													src="https://content.harstatic.com/media/icons/copilot/dote_vertical_dark.svg"
												/>
											</a>
											<div
												className="dropdown-menu pt-0 pb-0"
												aria-labelledby="dropdownMenuButton"
											>
												<a className="dropdown-item" href="#">
													<span className="color_sold">Delete</span>
												</a>
											</div>
										</div>
									</div>
									<div className="cphl_item">
										<a
											href="https://har.com"
											className="cphl_item_text overflow-ellipsis"
										>
											Calling script for the first contact
										</a>
										<div className="cphl_item_dropdown dropdown dropdown dropdown--custom dropdown--custom_medium">
											<a
												className="pr-3"
												href="#"
												id="dropdownMenuButton"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<img
													style={{ width: 14 }}
													src="https://content.harstatic.com/media/icons/copilot/dote_vertical_dark.svg"
												/>
											</a>
											<div
												className="dropdown-menu pt-0 pb-0"
												aria-labelledby="dropdownMenuButton"
											>
												<a className="dropdown-item" href="#">
													<span className="color_sold">Delete</span>
												</a>
											</div>
										</div>
									</div>
									<div className="font_size--medium font_weight--semi_bold pt-3 color_lighter">
										Older
									</div>
									<div className="cphl_item">
										<a
											href="https://har.com"
											className="cphl_item_text overflow-ellipsis"
										>
											Teg script for the first contact
										</a>
										<div className="cphl_item_dropdown dropdown dropdown dropdown--custom dropdown--custom_medium">
											<a
												className="pr-3"
												href="#"
												id="dropdownMenuButton"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<img
													style={{ width: 14 }}
													src="https://content.harstatic.com/media/icons/copilot/dote_vertical_dark.svg"
												/>
											</a>
											<div
												className="dropdown-menu pt-0 pb-0"
												aria-labelledby="dropdownMenuButton"
											>
												<a className="dropdown-item" href="#">
													<span className="color_sold">Delete</span>
												</a>
											</div>
										</div>
									</div>
									<div className="cphl_item active">
										<a
											href="https://har.com"
											className="cphl_item_text overflow-ellipsis"
										>
											Just Listed in 77027
										</a>
										<div className="cphl_item_dropdown dropdown dropdown dropdown--custom dropdown--custom_medium">
											<a
												className="pr-3"
												href="#"
												id="dropdownMenuButton"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<img
													style={{ width: 14 }}
													src="https://content.harstatic.com/media/icons/copilot/dote_vertical_dark.svg"
												/>
											</a>
											<div
												className="dropdown-menu pt-0 pb-0"
												aria-labelledby="dropdownMenuButton"
											>
												<a className="dropdown-item" href="#">
													<span className="color_sold">Delete</span>
												</a>
											</div>
										</div>
									</div>
									<div className="cphl_item">
										<a
											href="https://har.com"
											className="cphl_item_text overflow-ellipsis"
										>
											The first contact
										</a>
										<div className="cphl_item_dropdown dropdown dropdown dropdown--custom dropdown--custom_medium">
											<a
												className="pr-3"
												href="#"
												id="dropdownMenuButton"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<img
													style={{ width: 14 }}
													src="https://content.harstatic.com/media/icons/copilot/dote_vertical_dark.svg"
												/>
											</a>
											<div
												className="dropdown-menu pt-0 pb-0"
												aria-labelledby="dropdownMenuButton"
											>
												<a className="dropdown-item" href="#">
													<span className="color_sold">Delete</span>
												</a>
											</div>
										</div>
									</div>
									<div className="cphl_item">
										<a
											href="https://har.com"
											className="cphl_item_text overflow-ellipsis"
										>
											For the first contact
										</a>
										<div className="cphl_item_dropdown dropdown dropdown dropdown--custom dropdown--custom_medium">
											<a
												className="pr-3"
												href="#"
												id="dropdownMenuButton"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<img
													style={{ width: 14 }}
													src="https://content.harstatic.com/media/icons/copilot/dote_vertical_dark.svg"
												/>
											</a>
											<div
												className="dropdown-menu pt-0 pb-0"
												aria-labelledby="dropdownMenuButton"
											>
												<a className="dropdown-item" href="#">
													<span className="color_sold">Delete</span>
												</a>
											</div>
										</div>
									</div>
									<div className="cphl_item">
										<a
											href="https://har.com"
											className="cphl_item_text overflow-ellipsis"
										>
											Alling script for the first contact script for the first contact
										</a>
										<div className="cphl_item_dropdown dropdown dropdown dropdown--custom dropdown--custom_medium">
											<a
												className="pr-3"
												href="#"
												id="dropdownMenuButton"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<img
													style={{ width: 14 }}
													src="https://content.harstatic.com/media/icons/copilot/dote_vertical_dark.svg"
												/>
											</a>
											<div
												className="dropdown-menu pt-0 pb-0"
												aria-labelledby="dropdownMenuButton"
											>
												<a className="dropdown-item" href="#">
													<span className="color_sold">Delete</span>
												</a>
											</div>
										</div>
									</div>
									<div className="cphl_item ">
										<a
											href="https://har.com"
											className="cphl_item_text overflow-ellipsis"
										>
											Calling script for the first contact
										</a>
										<div className="cphl_item_dropdown dropdown dropdown dropdown--custom dropdown--custom_medium">
											<a
												className="pr-3"
												href="#"
												id="dropdownMenuButton"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<img
													style={{ width: 14 }}
													src="https://content.harstatic.com/media/icons/copilot/dote_vertical_dark.svg"
												/>
											</a>
											<div
												className="dropdown-menu pt-0 pb-0"
												aria-labelledby="dropdownMenuButton"
											>
												<a className="dropdown-item" href="#">
													<span className="color_sold">Delete</span>
												</a>
											</div>
										</div>
									</div>
									<div className="cphl_item">
										<a
											href="https://har.com"
											className="cphl_item_text overflow-ellipsis"
										>
											Teg script for the first contact
										</a>
										<div className="cphl_item_dropdown dropdown dropdown dropdown--custom dropdown--custom_medium">
											<a
												className="pr-3"
												href="#"
												id="dropdownMenuButton"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<img
													style={{ width: 14 }}
													src="https://content.harstatic.com/media/icons/copilot/dote_vertical_dark.svg"
												/>
											</a>
											<div
												className="dropdown-menu pt-0 pb-0"
												aria-labelledby="dropdownMenuButton"
											>
												<a className="dropdown-item" href="#">
													<span className="color_sold">Delete</span>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<br /><br /><br /><br />
					<div className="d-flex">
						<a href="#" className="btn_icon">
							<img src="https://content.harstatic.com/media/icons/copilot/har-ai-icon-like.svg" />
						</a>
						<a href="#" className="btn_icon">
							<img src="https://content.harstatic.com/media/icons/copilot/har-ai-icon-dislike.svg" />
						</a>
						<a href="#" className="btn_icon btn_icon_blue search_filters">
							<img
								className="ml-2 mr-2"
								src="https://content.harstatic.com/media/icons/filters_icon_for_search.svg"
							/>
							<span>Search Filter</span>
						</a>
					</div>





					<div className="container pt-5">
						<div className="pt-5 mt-5">
							<h3 className="mb-3">Status Labels</h3>
							<div className="pt-3 pb-3">
								<div className="label label--forsale">Active</div>
								<br /><br />
								<div className="label label--undercontract ">Under Contract - OP</div>
								<br /><br />
								<div className="label label--undercontract">Under Contract – PS</div>
								<br /><br />
								<div className="label label--undercontract">Under Contract – P</div>
								<br /><br />
								<div className="label label--sold">Sold/Rented</div>
								<br /><br />
							</div>
						</div>


						<div className="pt-5 mt-5">
							<h3 className="mb-3">Property Card</h3>
							<span style={{ whiteSpace: "normal" }}>
								<div className="border_radius--pudgy home_info_box p-2 position-relative" style={{ maxWidth: '700px' }}>
									<div className="d-flex align-items-center" style={{ maxWidth: 500 }}>
										<div
											className="bg--image border_radius--default mr-4"
											style={{
												backgroundImage:
													"url(https://listingmedia7.harstatic.com/430672935/lr/1.jpeg)",
												width: 250,
												height: 110
											}}
										/>
										<div className="font_size--medium">
											<div className="pb-2 font_weight--bold ">
												7 River Hollow Ln, Houston, TX 77027
											</div>
											<div className="d-flex mb-2">
												<div className="font_size--large font_weight--bold mr-3">
													$ 1,705,000
												</div>
												<div className="label label--forsale">Active</div>
											</div>
											<div className="font_size--medium flex-grow-1">
												Townhouse/Condo · 2 beds · 2 baths · 2 stories · 2,425 Sqft.
												($329/Sqft.) · 1971 year built
											</div>
										</div>
									</div>
								</div>
							</span>


							<br /><br /><br /><br />

							<h3 className="mb-3">Mini Property Card</h3>

							{/* card--mini v2 */}
							<div className="cardv2--mini cursor--pointer " style={{ maxWidth: '370px' }}>
								<div className="cardv2--mini__content">
									<div className="cardv2--mini__content__body">
										<a href="https://www.har.com/homedetail/120-carnarvon-dr-houston-tx-77024/3144594">
											{/* card img */}
											<div className="cardv2--mini__content__body__image">
												<div
													className="cardv2--mini__content__body__image__img bg__bottom"
													style={{
														backgroundImage:
															"url(https://photos.harstatic.com/297961427/hr/img-1.jpeg?ts=2024-09-04T16:49:07.777)"
													}}
												/>
											</div>
											{/* / card img */}
										</a>
										{/* card header */}
										{/* card details */}
										<div className="cardv2--mini__content__body__details">
											<div>
												<div className="cardv2--mini__content__body__details_address pb-2">
													<div className="cardv2--mini__content__body__details_address_left overflow-inherit">
														<div className="cardv2--mini__content__body__details_price pb-0">
															$425,000
														</div>
													</div>
													<div className="cardv2--mini__content__body__details_address_right">
														<div className="label label--forsale">Active</div>
													</div>
												</div>
												<div className="">
													<div className="cardv2--mini__content__body__details_address_left_add">
														15763 Tanya Cir
														<br />
														Houston, TX 77079
													</div>
													<div className="cardv2--mini__content__body__details_features">
														<ul>
															<li>4 - 5 beds</li>
															<li>3 baths</li>
															<li>3,808 sqft</li>
														</ul>
													</div>
													<div className="cardv2--mini__content__body__details_dayson">
														<div className="circle_nimber">1</div> Days on HAR
													</div>
												</div>
											</div>
										</div>
										{/* / card details */}
									</div>
									{/* / card body */}
								</div>
								{/* / card content */}
							</div>
							{/* / card--mini v2 */}
						</div>


						<div className="pt-5 mt-5 pb-5 mb-5">
							<h3 className="mb-3">View More Properties</h3>

							{/* Empty Card to view more */}
							<div className="cardv2 cardv2--portrait mb-0 h-100 empty_card cursor--pointer">
								<div>view more properties</div>
							</div>

						</div>


					</div>

				</div>
			</div>
		</div>
	);
}
